import type { ScheduledDeploymentSchema } from '@brighterion/types/scheduled-deployment';
import { getUnixTimestamp } from './date-timezone';

export const parseScheduledTime = (data: ScheduledDeploymentSchema) => {
    if (!data.deployNow && data.scheduledTime) {
        const unixTimestamp = getUnixTimestamp(data.scheduledTime);
        return { ...data, scheduledTime: unixTimestamp };
    }
    return { ...data, scheduledTime: undefined };
};
